import { CrossdockInboundShipment } from "common/clients/crossdock/CrossdockInboundShipment/CrossdockInboundShipment";
import { RootState } from "RootReducer";

export const getCrossdockInboundShipment = (state: RootState): CrossdockInboundShipment | undefined =>
  state.inbound.crossdock.shipment;
